<template>
  <v-card
    :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : 'pa-0'"
    style="max-width: 600px;margin-left: auto;margin-right:auto;"
    class="elevation-0"
  >
    <v-card-text>
      <div class="py-3">
        <h1 class="text-h5">
          Toimeksiantosopimus
        </h1>
        <p>Syötä pääsykoodi kirjautuaksesi sisään.</p>
      </div>
      <v-form
        @submit.prevent="submitCode()"
      >
        <v-text-field
          v-model="passCode"
          class="mt-3 mb-1"
          type="password"
          outlined
          hide-details
          append-icon="lock"
          label="Pääsykoodi"
        />
        <v-alert
          v-if="fail"
          type="warning"
          class="mt-2"
        >
          Virheellinen pääsykoodi. Yritä uudelleen
        </v-alert>
        <v-checkbox
          v-model="acceptGdpr"
          hide-details
          class="mt-3"
          label="Hyväksyn henkilötietojeni sähköisen käsittelyn"
        />
        <p class="text-caption mt-2">
          Toimeksiantosopimus edellyttää henkilötietojen automaattista käsittelyä ja tietojen
          tallennusta asiakasrekisteriimme.
          <a @click="showGdpr = true">
            EU:n tietosuoja-asetuksen (GDPR) mukainen tietosuojaseloste.
          </a>
        </p>
        <v-dialog v-model="showGdpr" max-width="600">
          <gdpr/>
        </v-dialog>
        <div class="grid grid-actions">
          <v-btn
            :disabled="!codeValid || !acceptGdpr"
            :loading="loading"
            color="primary"
            type="submit"
          >
            Ok
          </v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'AgreementPassCode',
  components: {
    gdpr: () => import('@/components/Gdpr'),
  },
  data: () => ({
    loading: false,
    passCode: '',
    acceptGdpr: false,
    fail: false,
    showGdpr: false,
  }),
  computed: {
    codeValid() {
      return this.passCode.length > 0;
    },
    id() {
      return +this.$route.params.id;
    },
    side() {
      return this.$route.params.side || '';
    },
  },
  methods: {
    ...mapActions({
      getPass: 'agreementPass/getOne',
      submitPass: 'agreementPass/create',
      getAgreement: 'commissionAgreement/getOne',
    }),
    async submitCode() {
      this.loading = true;
      try {
        await this.submitPass({
          data: {
            propertyId: this.id,
            passCode: this.passCode,
          },
        });
        const parameters = {};
        if (this.side) {
          parameters.side = this.side;
        }
        await this.getAgreement({ id: this.id, parameters });
        this.fail = false;
      } catch (e) {
        console.warn(e);
        this.fail = true;
      }
      this.loading = false;
    },
  },
};
</script>
